// src/hooks/useEcommerce.js
import { useCallback, useState } from "react";

export const useEcommerce = () => {
  const [isAddingToCart, setIsAddingToCart] = useState(false);

  const mivaAddToCart = useCallback(
    async (jsonBasket) => {
      if (isAddingToCart) {
        console.warn(
          "[useEcommerce] Already adding to cart, ignoring duplicate call",
        );
        return { success: false, error: "Already adding..." };
      }

      setIsAddingToCart(true);

      try {
        console.log("[useEcommerce] Adding to cart...");

        // Step 1: Add to cart
        const addResponse = await fetch(
          `/mm5/merchant.mvc?Screen=AJXATC&t=${Date.now()}`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(jsonBasket),
          },
        );

        if (!addResponse.ok) {
          const text = await addResponse.text();
          console.error(
            "[useEcommerce] Add to cart failed:",
            addResponse.status,
            text,
          );
          throw new Error(`Add to cart failed: ${addResponse.status}`);
        }

        const basketData = await addResponse.json();
        console.log("[useEcommerce] Add to cart success");

        // Step 2: Update pricing if needed
        if (basketData.response_update_price) {
          console.log("[useEcommerce] Updating price...");

          const jsonUpdateBasket = {
            function: "BasketItem_Update_Pricing",
            update_price: Number(basketData.response_update_price || 0).toFixed(
              8,
            ),
            basket_id: basketData.basket_id,
            product_code: basketData.product_code,
            session_id: basketData.session_id,
          };

          const updateResponse = await fetch(
            `/mm5/merchant.mvc?Screen=AJXUPC&t=${Date.now()}`,
            {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(jsonUpdateBasket),
            },
          );

          if (!updateResponse.ok) {
            const text = await updateResponse.text();
            console.error(
              "[useEcommerce] Price update failed:",
              updateResponse.status,
              text,
            );
            throw new Error(`Price update failed: ${updateResponse.status}`);
          }

          const updateData = await updateResponse.json();
          console.log("[useEcommerce] Price updated");
        }

        return { success: true, data: basketData };
      } catch (err) {
        console.error("[useEcommerce] Failed to add to cart:", err);
        throw err;
      } finally {
        setIsAddingToCart(false);
      }
    },
    [isAddingToCart],
  );

  return {
    mivaAddToCart,
    isAddingToCart,
  };
};
